import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "card-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "nav-card" }
const _hoisted_5 = { class: "nav-logo" }
const _hoisted_6 = { class: "logo-icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "nav-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "nav-menu-visual",
  "aria-hidden": "true"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "main-content" }
const _hoisted_13 = { class: "category-tabs" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "cards-grid" }
const _hoisted_16 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_17 = ["src", "poster", "onClick", "onLoadedmetadata", "onPlay", "onPause", "onEnded"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "video-status",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_21 = { class: "dock-bar" }

import logo2Image from '../assets/logo2.png'
import menuBgImage from '../assets/menu_bg.jpg'
import ParentPasswordModal from '../components/ParentPasswordModal.vue'
import LoginPromptModal from '@/components/LoginPromptModal.vue'
import VipPromptModal from '@/components/VipPromptModal.vue'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getTprList, type TprVO } from '@/api/course-tpr'
import { addHistory } from '@/api/history'
import { getAccessToken } from '@/config/axios/auth'

const TPR_CONTENT_TYPE = 3


export default /*@__PURE__*/_defineComponent({
  __name: 'tpr',
  setup(__props) {

const isGuestUser = computed(() => getAccessToken() == null)
const isNonVipUser = computed(() =>
  !isGuestUser.value && localStorage.getItem('vipTag') === 'false'
)

const route = useRoute()
const router = useRouter()
const activeTab = ref('body')
const activeNav = ref('')
const currentPlayingIndex = ref(-1)
const playingCardId = ref(null)
const isHeaderScrolled = ref(false)
const isAutoPlaying = ref(false)
const pausedIndex = ref(-1)
const parentPasswordModalRef = ref(null)
const isLoginPromptOpen = ref(false)
const isVipPromptOpen = ref(false)
let autoPlayTimer = null
const isLoading = ref(false)
const historyRecordedIds = new Set<number>()
const videoAspectRatios = ref<Record<string, string>>({})

const cardVideoRefs = new Map()

const navItems = [
  { id: 'home', label: '首页', icon: 'home' },
  { id: 'history', label: '观看历史', icon: 'play-circle' },
  { id: 'favorites', label: '宝贝收藏', icon: 'heart' },
  { id: 'settings', label: '偏好设置', icon: 'cog' },
  { id: 'parent', label: '家长模式', icon: 'user-shield' },
]


const tabs = [
  { id: 'body', label: '身体指令', icon: 'hand-paper' },
  { id: 'daily', label: '日常生活', icon: 'home' },
  { id: 'emotion', label: '情绪感受', icon: 'smile' },
]

const queryParams = ref({
  category: tabs[0].label,
  stage: route.query.stage
})

const tprList = ref<TprVO[]>([])

const cardColors = [
  'rgba(255, 140, 66, 0.15)',
  'rgba(91, 143, 249, 0.15)',
  'rgba(76, 175, 80, 0.15)',
  'rgba(231, 76, 60, 0.15)',
  'rgba(255, 193, 7, 0.15)',
  'rgba(156, 39, 176, 0.15)',
  'rgba(0, 150, 136, 0.15)',
  'rgba(33, 150, 243, 0.15)'
]

const filteredCards = computed(() => {
  return tprList.value.map((item, index) => ({
    ...item,
    bgColor: cardColors[index % cardColors.length]
  }))
})

const showTprSkeleton = computed(() => isLoading.value && filteredCards.value.length === 0)

const selectTab = (tab) => {
  activeTab.value = tab.id
  queryParams.value.category = tab.label
  getList()
}

watch(activeTab, () => {
  stopAutoPlay()
  pauseAllVideos()
  currentPlayingIndex.value = -1
  playingCardId.value = null
  pausedIndex.value = -1
})

const setCardVideoRef = (cardId, el) => {
  if (el) {
    cardVideoRefs.set(cardId, el)
    return
  }

  cardVideoRefs.delete(cardId)
}

const getCardAspectRatio = (cardId) => {
  return videoAspectRatios.value[String(cardId)] || '4 / 5'
}

const handleVideoMetadata = (cardId, event: Event) => {
  const video = event.target as HTMLVideoElement | null
  if (!video?.videoWidth || !video?.videoHeight) {
    return
  }

  const cardKey = String(cardId)
  videoAspectRatios.value = {
    ...videoAspectRatios.value,
    [cardKey]: `${video.videoWidth} / ${video.videoHeight}`
  }
}

const openLoginPrompt = () => {
  isLoginPromptOpen.value = true
}

const goLogin = () => {
  isLoginPromptOpen.value = false
  router.push('/login')
}

const goVip = () => {
  isVipPromptOpen.value = false
  router.push('/vip')
}

const ensureCanPlayTpr = () => {
  if (isGuestUser.value) {
    openLoginPrompt()
    return false
  }

  if (isNonVipUser.value) {
    isVipPromptOpen.value = true
    return false
  }

  return true
}

const playVideo = async (video, restart = false) => {
  if (!video) return

  if (restart) {
    video.currentTime = 0
  }

  try {
    await video.play()
  } catch (error) {
    // Ignore blocked autoplay and keep the UI responsive.
  }
}

const pauseAllVideos = (exceptId = null) => {
  cardVideoRefs.forEach((video, cardId) => {
    if (!video || cardId === exceptId) return
    video.pause()
    video.currentTime = 0
  })
}

const playCardAtIndex = async (index, restart = true) => {
  if (!ensureCanPlayTpr()) {
    return
  }

  const card = filteredCards.value[index]
  if (!card) return

  const video = cardVideoRefs.get(card.id)
  if (!video) return

  currentPlayingIndex.value = index
  pausedIndex.value = index
  pauseAllVideos(card.id)
  await playVideo(video, restart)
}

const handleGoBack = () => {
  if (window.history.length > 1) {
    router.back()
    return
  }

  router.push('/category')
}

const openParentPasswordModal = () => {
  parentPasswordModalRef.value?.open()
}

const handleNavItemClick = (item) => {
  if (item.id === 'home') {
    router.push('/')
    return
  }

  if (item.id === 'parent') {
    openParentPasswordModal()
    return
  }

  if (item.id === 'settings') {
    router.push('/preference')
    return
  }

  if (item.id === 'history' || item.id === 'favorites') {
    router.push({
      path: '/history',
      query: item.id === 'favorites' ? { tab: 'favorites' } : {}
    })
  }
}

const handleCardClick = async (card, index) => {
  if (!ensureCanPlayTpr()) {
    return
  }

  const video = cardVideoRefs.get(card.id)
  if (!video) return

  if (currentPlayingIndex.value === index && !video.paused && !video.ended) {
    video.pause()
    return
  }

  await playCardAtIndex(index, currentPlayingIndex.value !== index)
}

const handleVideoElementClick = (card, index) => {
  const video = cardVideoRefs.get(card.id)
  if (!video) return

  if (currentPlayingIndex.value !== index) {
    handleCardClick(card, index)
  }
}

const handleVideoPlay = (cardId, index) => {
  if (!ensureCanPlayTpr()) {
    const video = cardVideoRefs.get(cardId)
    if (video) {
      video.pause()
      video.currentTime = 0
    }
    return
  }

  currentPlayingIndex.value = index
  playingCardId.value = cardId
  pauseAllVideos(cardId)
  if(!isGuestUser.value) {
    addPlayHistory(cardId)
  }
}

const addPlayHistory = (cardId) => {
  if (historyRecordedIds.has(cardId)) {
    return
  }

  historyRecordedIds.add(cardId)
  addHistory({
    contentType: TPR_CONTENT_TYPE,
    contentId: cardId
  }).catch(() => {
    historyRecordedIds.delete(cardId)
  })
}

const handleVideoPause = (cardId) => {
  if (playingCardId.value === cardId) {
    playingCardId.value = null
  }
}

const handleVideoEnded = (cardId) => {
  if (playingCardId.value === cardId) {
    playingCardId.value = null
  }
}

const handlePageScroll = () => {
  isHeaderScrolled.value = window.scrollY > 12
}

const getList = async () => {
  if (isLoading.value) {
    return
  }

  isLoading.value = true
  try {
    tprList.value = await getTprList(queryParams.value) || []
  } catch {
    tprList.value = []
  } finally {
    isLoading.value = false
  }
}

const goToFullscreen = () => {
  if (!ensureCanPlayTpr()) {
    return
  }

  router.push({
    path: '/tpr-fullscreen',
    query: {
      category: queryParams.value.category,
      stage: queryParams.value.stage
    }
  })
}

const toggleAutoPlay = () => {
  if (isAutoPlaying.value) {
    stopAutoPlay()
  } else {
    if (!ensureCanPlayTpr()) {
      return
    }

    startAutoPlay()
  }
}

const startAutoPlay = async () => {
  if (filteredCards.value.length === 0) return

  if (pausedIndex.value >= 0) {
    currentPlayingIndex.value = pausedIndex.value
  } else {
    currentPlayingIndex.value = 0
  }

  await playCardAtIndex(currentPlayingIndex.value)
  isAutoPlaying.value = true

  autoPlayTimer = window.setInterval(async () => {
    const nextIndex = (currentPlayingIndex.value + 1) % filteredCards.value.length
    await playCardAtIndex(nextIndex)
  }, 3000)
}

const stopAutoPlay = () => {
  isAutoPlaying.value = false
  pausedIndex.value = currentPlayingIndex.value

  if (autoPlayTimer) {
    window.clearInterval(autoPlayTimer)
    autoPlayTimer = null
  }
}

onMounted(() => {
  getList()
  window.addEventListener('scroll', handlePageScroll, { passive: true })
  handlePageScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handlePageScroll)
  stopAutoPlay()
  pauseAllVideos()
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bg-gradient" }, null, -1)),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "orb orb-1" }, null, -1)),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "orb orb-2" }, null, -1)),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "orb orb-3" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(logo2Image),
                alt: "",
                class: "logo2-icon"
              }, null, 8, _hoisted_7)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "brand-copy" }, [
              _createElementVNode("h1", { class: "brand-name" }, "树苗英语"),
              _createElementVNode("span", { class: "brand-subtitle" }, "TREE SAPLING")
            ], -1))
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("li", {
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (handleNavItemClick(item)), ["prevent"]),
                  class: _normalizeClass(['nav-item', { active: activeNav.value === item.id }])
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon,
                    class: "nav-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_9)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(menuBgImage),
              alt: "",
              class: "nav-menu-image"
            }, null, 8, _hoisted_11)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_12, [
        _createElementVNode("header", {
          class: _normalizeClass(["page-header", { 'is-scrolled': isHeaderScrolled.value }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "mobile-back-btn",
            onClick: handleGoBack,
            "aria-label": "返回上一页"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "main-title" }, [
            _createTextVNode(" TPR "),
            _createElementVNode("span", { class: "highlight" }, "互动卡")
          ], -1))
        ], 2),
        _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "page-header-spacer",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("nav", _hoisted_13, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createElementVNode("button", {
              key: tab.id,
              type: "button",
              class: _normalizeClass(["tab-item", { active: activeTab.value === tab.id }]),
              onClick: ($event: any) => (selectTab(tab))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: tab.icon,
                class: "tab-icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(tab.label), 1)
            ], 10, _hoisted_14)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (showTprSkeleton.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (index) => {
                return _createElementVNode("article", {
                  key: `tpr-skeleton-${index}`,
                  class: "word-card tpr-skeleton-card"
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "card-surface" }, [
                    _createElementVNode("div", { class: "card-video-wrap tpr-skeleton-media" })
                  ], -1)
                ]))])
              }), 64))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showTprSkeleton.value ? [] : filteredCards.value, (card, index) => {
            return (_openBlock(), _createElementBlock("article", {
              key: card.id,
              class: _normalizeClass(["word-card", { playing: currentPlayingIndex.value === index }])
            }, [
              _createElementVNode("div", {
                class: "card-surface",
                "aria-label": `播放第 ${index + 1} 个视频`,
                role: "button",
                tabindex: "0",
                onClick: ($event: any) => (handleCardClick(card, index)),
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (handleCardClick(card, index)), ["prevent"]), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (handleCardClick(card, index)), ["prevent"]), ["space"])
                ]
              }, [
                _createElementVNode("div", {
                  class: "card-video-wrap",
                  style: _normalizeStyle({
                  background: card.bgColor,
                  '--tpr-video-aspect-ratio': getCardAspectRatio(card.id)
                })
                }, [
                  _createElementVNode("video", {
                    ref_for: true,
                    ref: (el) => setCardVideoRef(card.id, el),
                    class: _normalizeClass(["card-video", { active: currentPlayingIndex.value === index }]),
                    src: card.videoUrl,
                    poster: card.coverUrl,
                    playsinline: "",
                    preload: "auto",
                    controlslist: "nodownload nofullscreen noremoteplayback",
                    disablepictureinpicture: "",
                    onClick: _withModifiers(($event: any) => (handleVideoElementClick(card, index)), ["stop"]),
                    onLoadedmetadata: ($event: any) => (handleVideoMetadata(card.id, $event)),
                    onPlay: ($event: any) => (handleVideoPlay(card.id, index)),
                    onPause: ($event: any) => (handleVideoPause(card.id)),
                    onEnded: ($event: any) => (handleVideoEnded(card.id))
                  }, null, 42, _hoisted_17),
                  (playingCardId.value !== card.id && card.coverUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: card.coverUrl,
                        alt: "",
                        class: "card-video-cover"
                      }, null, 8, _hoisted_18))
                    : _createCommentVNode("", true),
                  (playingCardId.value !== card.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_font_awesome_icon, { icon: "play" })
                      ]))
                    : _createCommentVNode("", true)
                ], 4)
              ], 40, _hoisted_16)
            ], 2))
          }), 128)),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_font_awesome_icon, { icon: "hand-paper" }),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "暂无 TPR 内容", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        class: "dock-item dock-item-secondary",
        onClick: goToFullscreen
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "expand" }),
        _cache[7] || (_cache[7] = _createElementVNode("span", null, "全屏模式", -1))
      ]),
      _createElementVNode("button", {
        class: "dock-item main-btn dock-play-btn",
        onClick: toggleAutoPlay
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: isAutoPlaying.value ? 'pause' : 'play'
        }, null, 8, ["icon"])
      ])
    ]),
    _createVNode(ParentPasswordModal, {
      ref_key: "parentPasswordModalRef",
      ref: parentPasswordModalRef
    }, null, 512),
    _createVNode(LoginPromptModal, {
      modelValue: isLoginPromptOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLoginPromptOpen).value = $event)),
      onConfirm: goLogin
    }, null, 8, ["modelValue"]),
    _createVNode(VipPromptModal, {
      modelValue: isVipPromptOpen.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isVipPromptOpen).value = $event)),
      description: "成为会员后可观看完整内容",
      onConfirm: goVip
    }, null, 8, ["modelValue"])
  ]))
}
}

})